import { Phone, Mail, MapPin, Instagram } from "lucide-react";

export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-[#F5EFE6]/85 backdrop-blur-xl border-b border-stone-900/15">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="brand-logo">
          <span className="w-8 h-8 bg-stone-950 grid place-items-center text-amber-500 font-display font-black text-xs italic">SH</span>
          <span className="font-display font-light tracking-[-0.02em] text-stone-950 text-lg sm:text-xl">
            Swift<span className="italic text-amber-800">haul</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-10 text-sm font-medium text-stone-700">
          <a href="#services" className="hover:text-amber-800 transition-colors">Services</a>
          <a href="#gallery" className="hover:text-amber-800 transition-colors">Our Work</a>
          <a href="#contact" className="hover:text-amber-800 transition-colors">Contact</a>
        </nav>
        <a href="tel:5038679622" className="hidden sm:flex items-center gap-2 text-xs font-medium text-stone-900 tracking-[0.15em] uppercase border border-stone-900 rounded-full px-4 py-2 hover:bg-stone-950 hover:text-amber-500 transition-colors">
          <Phone className="w-3.5 h-3.5" />
          <span>503-867-9622</span>
        </a>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer id="contact" className="bg-stone-950 text-stone-100 pt-24 pb-10 relative overflow-hidden">
      <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <h3 className="font-display text-4xl sm:text-5xl md:text-6xl font-light tracking-[-0.03em] leading-[0.95]">
              Ready to <span className="italic text-amber-500">move?</span>
            </h3>
            <p className="mt-6 text-stone-300 max-w-md leading-relaxed">
              Tell us about the move. We'll reply within an hour with a flat-rate quote, no obligation.
            </p>
            <a href="#top" className="inline-flex items-center gap-2 mt-8 text-xs tracking-[0.25em] uppercase font-semibold text-amber-500 hover:text-amber-300 transition-colors">
              Get a quote <span aria-hidden>→</span>
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.4em] uppercase font-semibold text-amber-500 mb-5">Reach us</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-amber-500" /> 503-867-9622</li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-amber-500" /> swifthaul001@gmail.com</li>
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-amber-500" /> Tri-state area</li>
              <li className="flex items-center gap-3"><Instagram className="w-4 h-4 text-amber-500" /> @swifthaul</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-[10px] tracking-[0.4em] uppercase font-semibold text-amber-500 mb-5">Hours</p>
            <ul className="space-y-2 text-sm text-stone-300">
              <li>Mon – Thu, Sat</li>
              <li>7am – 9pm</li>
              <li className="text-amber-500 font-medium pt-2">Fri & Sun by appt</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-[10px] tracking-[0.4em] uppercase font-semibold text-amber-500 mb-5">Sitemap</p>
            <ul className="space-y-2 text-sm text-stone-300">
              <li><a href="#services" className="hover:text-amber-500">Services</a></li>
              <li><a href="#gallery" className="hover:text-amber-500">Our Work</a></li>
              <li><a href="#top" className="hover:text-amber-500">Quote</a></li>
            </ul>
          </div>
        </div>

        {/* Big wordmark */}
        <div className="py-12 text-center">
          <h4 className="font-display text-[20vw] md:text-[14vw] font-light tracking-[-0.05em] leading-none text-stone-100/95 select-none">
            Swift<span className="italic text-amber-500">haul</span>
          </h4>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-2 text-xs text-stone-400">
          <span>© {new Date().getFullYear()} SWIFTHAUL Moving & Junk Removal</span>
          <span className="tracking-[0.2em] uppercase">Licensed · Bonded · Insured</span>
        </div>
      </div>
    </footer>
  );
}
